
export const NOTIFICATION_EVENTS = {
  REQUEST_ACCEPTED: 'notification:request-accepted',
  REQUEST_DECLINED: 'notification:request-declined',
  REFRESH_NOTIFICATIONS: 'notification:refresh',
};


export const emitRequestAccepted = (requestId, fromUserId = null) => {
  const event = new CustomEvent(NOTIFICATION_EVENTS.REQUEST_ACCEPTED, {
    detail: { requestId, fromUserId, timestamp: Date.now() }
  });
  window.dispatchEvent(event);
};

export const emitRequestDeclined = (requestId, fromUserId = null) => {
  const event = new CustomEvent(NOTIFICATION_EVENTS.REQUEST_DECLINED, {
    detail: { requestId, fromUserId, timestamp: Date.now() }
  });
  window.dispatchEvent(event);
};


export const emitRefreshNotifications = () => {
  const event = new CustomEvent(NOTIFICATION_EVENTS.REFRESH_NOTIFICATIONS, {
    detail: { timestamp: Date.now() }
  });
  window.dispatchEvent(event);
};


export const subscribeToNotificationEvent = (eventType, callback) => {
  window.addEventListener(eventType, callback);
  return () => window.removeEventListener(eventType, callback);
};
